import React from "react";
import { SectionContainerBase, CollapsibleAccordion } from "@reusejs/react";
import { QuestionMarkCircleIcon } from "@heroicons/react/solid";

const FaqExpandedComponent = (props: any) => {
  return <div>{props.text}</div>;
};

const FaqLabel = (props: any) => {
  return (
    <div className="flex items-center ">
      <div>
        <QuestionMarkCircleIcon className="h-5 w-5 text-gray-600" />
      </div>

      <p className="ml-2">{props.label}</p>
    </div>
  );
};

const faqsData = [
  {
    labelBaseProps: {
      label: <FaqLabel label="What are VALUE ADDED SERVICES?" />,
    },
    content: FaqExpandedComponent,
    contentProps: {
      text: (
        <p>
          Value added service (“VAS”) is a unique service (Subscription
          basis/paid service) offered by us.It involves carrying out legal and
          technical verification of property and giving independent report to
          bidder. Which will help the potential buyer enter the auction process
          with complete information and legal and technical know-how of the
          property he is interested in. This will also help the interested buyer
          in placing the bid at a fair value so that he gets that advantage of
          buying property lower than the market value.
        </p>
      ),
    },
    accordionBaseClasses: {},
  },
  {
    labelBaseProps: {
      label: <FaqLabel label="What is legal verification?" />,
    },
    content: FaqExpandedComponent,
    contentProps: {
      text: (
        <p>
          A team of experts will carry out several checks on the property for
          sale. Since the borrower is already a defaulter in nature, legal
          experts will ensure no stone left unturned Highlight each and every
          issue/charges/pending bills/other lis pendens to help the bidder in
          proceeding or not with the auction this includes verification of all
          original documents including title deeds , NOC if any and other
          ownership papers.
        </p>
      ),
    },
    accordionBaseClasses: {},
  },
  {
    labelBaseProps: {
      label: <FaqLabel label="What is technical evaluation of property?" />,
    },
    content: FaqExpandedComponent,
    contentProps: {
      text: (
        <p>
          A team of experts will visit the property to check its physical
          status, locality-specific considerations and building specifications,
          to arrive at its fair market value. This is a critical step for any
          bidder to ascertain what can be his upper threshold for bidding.
        </p>
      ),
    },
    accordionBaseClasses: {},
  },
  {
    labelBaseProps: {
      label: <FaqLabel label="What is the combined valuation report?" />,
    },
    content: FaqExpandedComponent,
    contentProps: {
      text: (
        <p>
          We will appoint 2 different agencies consisting legal and technical
          experts who will do legal and technical analysis of these properties
          and the 2 independent reports will be submitted to inhouse
          legal/technical expert for approval. This will be duly verified
          approved before handing over to subscribers of legal and technical
          verification services.
        </p>
      ),
    },
    accordionBaseClasses: {},
  },
  {
    labelBaseProps: {
      label: (
        <FaqLabel label="What is the Turnaround Time for Valuation Report?" />
      ),
    },
    content: FaqExpandedComponent,
    contentProps: {
      text: (
        <p>
          We will start to work on the property analysis very next moment
          subscriber opt for this service, typically these reports will be
          shared with in 7 business days, however any delays arises due to
          document not availability can take more time.
        </p>
      ),
    },
    accordionBaseClasses: {},
  },
];

export default function FaqCollapsibleSection() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-10 md:py-20",
        innerContainerStyles: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-0",
      }}
    >
      <CollapsibleAccordion accordionList={faqsData} />
    </SectionContainerBase>
  );
}
